import { http } from '../../../common/http/client';
import { type Page, toPage } from '../../../common/helpers/linkHeaderHelper';
import { Company, QueryParams } from './company';

export function searchCompanies(
  page: number,
  query: QueryParams,
  signal?: AbortSignal,
): Promise<Page<Company>> {
  // http は qs を使わないため、ransack の q[...] はここでキーを平坦にする
  const q = Object.fromEntries(
    Object.entries(query).map(([key, value]) => [`q[${key}]`, value]),
  );
  return http
    .request<Company[]>('/api/v1/companies/search.json', {
      params: { page: page, ...q },
      signal: signal,
    })
    .then(toPage);
}
